/* eslint-disable react-hooks/exhaustive-deps */
import actions from "@/modules/pe-basic-module/data/actions"
import { UPDATE_SINGLE_TYPE } from "@/modules/pe-basic-module/data/actionTypes"
import { ITrack } from "@/modules/pe-fest-module/data/interfaces"
import { IFestDataStor, useFestDataStore } from "@/modules/pe-fest-module/data/store"
import { useIsTrackModerator } from "@/modules/pe-fest-module/hooks/track"
import { isRole } from "@/settings/zustand/user"
import { Intent } from "@blueprintjs/core"
import { ID } from "@libs/interfaces/layouts"
import FieldInput, { SCALAR_TYPES } from "@libs/scalars"
import ConfirmButton from "@libs/useful/ConfirmButton"
import { __ } from "@libs/utilities"
import { useEffect, useState } from "react"
import { showToast } from "src/libs/useful"

/* Protopia Ecosystem component */
export interface ITrackEditorProps {
   item: ITrack | null

}
const TrackEditor = (props: ITrackEditorProps): JSX.Element => {
    const landId: ID        = useFestDataStore((state: IFestDataStor) => state.festId)
    const [item, setItem]   = useState<ITrack>(props.item ? props.item : {} as ITrack)
    const isModerator : boolean = useIsTrackModerator(item)

    useEffect(() => {
        setItem({...item, ...props.item})
    }, [ props.item ])

    const onField = (value: any, field: keyof ITrack, data: any = null) => {
        console.log(data)
        setItem({
            ...item,
            [field]: value
        })
        if(field === "illustration") {
            setItem({
                ...item,
                [field]: value,
                "illustration_name": data?.name
            })
        }
    }
    const editTrack = ( ) => {
        let input = {
            illustration: item.illustration,
            illustration_name: item.illustration_name,
            title: item.title,
            content: item.content,
            video_id: item.video_id,
            vk_url: item.vk_url,
            is_closed: item.is_closed,
            // last_ad: item.last_ad?.id,
            moderator: item.moderator?.id,
            moderator2: item.moderator2?.id,
            images: item.moderator2?.images
        } 
        // console.log( input )
        actions(UPDATE_SINGLE_TYPE, {
            data_type: "PEFestTrack",
            id: item.id,
            landId,
            item: input
        })
        .then(res => showToast({
            message: __("Update successfully")
        }))
    }

    return isModerator || isRole([ "administrator", "SuperAdmin" ])
        ?
        <ConfirmButton
            buttonIntent={Intent.DANGER}
            buttonMinimal
            buttonIcon="edit"
            onConfirm={editTrack}
            buttonClassName="ml-3"
            dialogTitle={__("Edit Track")}
        >
            <div className="p-4 overflow-y-auto" style={{maxHeight: "calc(100vh - 200px)"}}> 
                <FieldInput
                    value={item.illustration} 
                    title={__("Illustration")}
                    onChange={(value, field, data) => onField(value, "illustration", field)}
                    type={SCALAR_TYPES.MEDIA}
                />
                <FieldInput
                    value={item.title}
                    editable
                    title={__("Title")}
                    onChange={value => onField(value, "title")}
                />
                <FieldInput
                    value={item.content}
                    editable
                    title={__("Content")}
                    onChange={value => onField(value, "content")}
                    type={SCALAR_TYPES.TEXT}
                />
                <FieldInput
                    value={item.moderator}
                    editable
                    title={__("Moderator")}
                    onChange={value => onField(value, "moderator")}
                    type={SCALAR_TYPES.USER}
                />
                <FieldInput
                    value={item.moderator2}
                    editable
                    title={__("Moderator 2")}
                    onChange={value => onField(value, "moderator2")}
                    type={SCALAR_TYPES.USER}
                />
                <FieldInput
                    value={item.last_ad}
                    editable
                    title={__("Last Ad")}
                    component="Ad"
                    landId={landId}
                    onChange={value => onField(value, "last_ad")}
                    type={SCALAR_TYPES.EXTERNAL}
                /> {/* */}
                <FieldInput
                    value={ item.video_id }
                    editable
                    title={ __( "Video" ) }
                    width={ "100%" }
                    onChange={ value => onField(value, "video_id") }
                    type={ SCALAR_TYPES.YOUTUBE_ID }
                />
                <FieldInput
                    value={item.vk_url}
                    editable
                    title={__("VK group")}
                    onChange={value => onField(value, "vk_url")}
                    type={SCALAR_TYPES.STRING}
                />
                <FieldInput
                    value={item.images}
                    editable
                    title={__("Gallery")}
                    onChange={value => onField(value, "images")}
                    component="media"
                    notClear
                    type={SCALAR_TYPES.ARRAY}
                />
                <FieldInput
                    value={item.is_closed}
                    editable
                    title={__("Is closed")}
                    onChange={value => onField(value, "is_closed")}
                    type={SCALAR_TYPES.BOOLEAN}
                />

            </div>
        </ConfirmButton>
        :
        <></> 
}
export default TrackEditor